export const textLabels = {
    noResultsMessage: "Результаты не найдены", // сообщение для отсутвующих результатов в Dropdown
    placeholderMessage: "Не выбран", // сообщение для невыбранного значения в Dropdown
    createButton: "Добавить", // кнопка Добавить
    editButton: "Изменить", // кнопка Изменить
    deleteButton: "Удалить", // кнопка Удалить
    returnButton: "Назад", // кнопка Назад
    saveButton: "Сохранить", // кнопка Сохранить
    cancelButton: "Отмена", // кнопка Отмена
    listLoaderMessage: "Список загружается...", // сообщение при ожидании загрузке списка
    errorMessage: "Ошибка", // сообщение о наличии ошибки
};